<script setup lang="ts">
import { faStar as faFilledStar } from '@fortawesome/pro-solid-svg-icons';
import { faStar as faEmptyStar } from '@fortawesome/pro-light-svg-icons';

const model = defineModel<number>({ default: 0 });
const hovered = ref(0);
const starMap = computed(() => {
    const max = Math.max(hovered.value, model.value, 0);
    return Array(5)
        .fill(faEmptyStar)
        .map((_, index) => (index + 1 > max ? faEmptyStar : faFilledStar));
});
</script>
<template>
    <div class="rating-root">
        <div class="rating-container" @mouseout="hovered = 0">
            <mr-icon
                v-for="index in 5"
                :key="index"
                :icon="starMap[index - 1]"
                color="var(--yellow-400)"
                primary-color="var(--yellow-200)"
                secondary-color="var(--yellow-400)"
                class="clickable"
                @mouseover="hovered = index"
                @mouseout.prevent.stop
                @click="model = index"
            />
        </div>
    </div>
</template>
<style scoped lang="scss">
.rating-root {
    display: flex;
    .rating-container {
        display: flex;
        gap: 12px;
        padding: 8px;
        .clickable {
            cursor: pointer;
        }
    }
}
</style>
